import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang); // optional: persist language
  };

  return (
    <div className="language-switcher">
      <button onClick={() => handleChangeLanguage('en')}>EN</button>
      <button onClick={() => handleChangeLanguage('de')}>DE</button>
      <button onClick={() => handleChangeLanguage('tr')}>TR</button>
    </div>
  );
};

export default LanguageSwitcher;
